import React from 'react'
import moment from 'moment'
import TableHeader from './TableHeader'

const ReferralsList = ({
  referrals = [],
  total = 0,
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Referrals list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} referrals</p>
        </div>
      </div>

      <div className='Table Table--referrals-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'Referrer ID',
            },
            {
              label: 'Referred ID',
            },
            {
              label: 'Action',
            },
            {
              label: 'Referral Type'

            },
            {
              label: 'Created at',
            },
            {
              label: 'UUID matches Referred'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {referrals.map((referral, i) => (
          <div
            className='Table__row'
            key={`${i}_${referral.createdAt}`}
          >
            <div className='Table__col'>
              <a
                className='DotTooltip__link'
                href={`/${gon.currentProvider}/users/${referral.referrerId}`}
              >
                {referral.referrerId}
              </a>
            </div>
            <div className='Table__col'>
              <a
                className='DotTooltip__link'
                href={`/${gon.currentProvider}/users/${referral.referredId}`}
              >
                {referral.referredId}
              </a>
            </div>
            <div className='Table__col'>{referral.action}</div>
            <div className='Table__col'>{referral.referralType}</div>
            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: referral.createdAt !== null ?
                    moment(referral.createdAt).format('YYYY-MM-DD HH:mm')
                    :
                    'N/A'
                }
              }
            />
            <div className='Table__col'>{referral.uuidMatchesReferred}</div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default ReferralsList
